module.exports = __webpack_public_path__ + "static/media/female_arterien.54465468.png";